import React from "react";
import { Layout } from "antd";

import SidebarComponent from "../components/shared/layout/AppSidebar.tsx";
import HeaderComponent from "../components/shared/layout/AppHeader.tsx";
import { Outlet,useLocation, useParams } from 'react-router-dom';
import BreadcrumbComponent from "../components/shared/layout/AppBreadcrumb.tsx";
import FooterComponent from "../components/shared/layout/AppFooter.tsx";
import { useGetConfigurationDisplayListQuery } from "../services/ApiSlice.ts";
import CustomSpinner from "../components/core/spinner/CustomSpinner.tsx";
import ConfigurationToolbar from "../components/features/configurationEdit/configurationToolbar.tsx";
import "./AppLayout.css";
import "../global.css";

const { Content } = Layout;
interface AppLayoutProps {
}

const AppLayout: React.FC<AppLayoutProps> = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const isLandingPage = location.pathname === "/";
  const { configurationId : currentConfigurationId } = useParams(); 

  const { data: configurationDisplays = [], isLoading } = useGetConfigurationDisplayListQuery(undefined, {skip: isLoginPage, refetchOnMountOrArgChange: true});

  const toolbar = currentConfigurationId ? (
    <ConfigurationToolbar
      configurationId={currentConfigurationId}
      configurationList={configurationDisplays}
      onRefresh={() => {}}
    />
  ) : null;

  return (
      <Layout>
        <HeaderComponent />
        <Layout
          className={`sidebar-layout ${
            isLoginPage ? "no-content-layout" : "content-layout"
          }`}
        >
          {!isLoginPage && (
            <SidebarComponent configurationDisplays={configurationDisplays} />
          )}

          {isLoading ? (
            <CustomSpinner />
          ) : (
            <Layout>
              {!isLoginPage && !isLandingPage && (
                <BreadcrumbComponent
                  configurationDisplays={configurationDisplays}
                  toolbar={toolbar}
                />
              )}
              <Content
                className={
                  isLoginPage || isLandingPage ? "login-content" : "content"
                }
              >
                <Outlet />
              </Content>
            </Layout>
          )}
        </Layout>
        <FooterComponent />
      </Layout>
    );
  };

  export default AppLayout;
